export function BreadCrumbs(props: any) {
  const { isActionItems, label, items, className = '' } = props

  return (
    <div
      className={`d-flex flex-wrap justify-content-between align-items-center gap-3 my-4 ${className}`}
    >
      <div className='d-flex flex-column flex-grow-1'>
        <div className='d-flex flex-wrap align-items-baseline border-4 border-start border-primary ps-4'>
          <h2 className='mb-0 fw-bold my-1'>{label}</h2>
          {!isActionItems && items && <div className='ms-3 mt-1'>{items}</div>}
        </div>
      </div>

      {isActionItems && items && (
        <div className='d-flex justify-content-end align-items-center ms-auto mt-2 mt-md-0'>
          <div className='ms-md-3'>{items}</div>
        </div>
      )}
    </div>
  )
}
